"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function createHandler(el, setInView, options) {
  var _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 0.5 : _options$threshold,
      _options$unobserveAft = options.unobserveAfterEntry,
      unobserveAfterEntry = _options$unobserveAft === void 0 ? false : _options$unobserveAft;
  return function (entries, instance) {
    var isInView = entries[0].intersectionRatio > threshold;
    setInView(isInView);

    if (isInView && unobserveAfterEntry) {
      instance.unobserve(el);
    }
  };
}

var _default = createHandler;
exports.default = _default;